import { useQuery } from '@tanstack/react-query';

import { withError } from '@/react-tools/react-query';
import axios, { parseAxiosError } from '@/portainer/services/axios/axios';

import { PolicyCategory, PolicyTemplate, PolicyType } from '../types';

import { queryKeys } from './query-keys';

interface PolicyTemplatesResponse {
  templates: Array<PolicyTemplate>;
}

interface UsePolicyTemplatesOptions {
  category?: PolicyCategory;
  type?: PolicyType;
}

export function usePolicyTemplates(options?: UsePolicyTemplatesOptions) {
  return useQuery({
    queryKey: queryKeys.templates(options),
    queryFn: () => getPolicyTemplates(options),
    ...withError('Unable to load policy templates'),
  });
}

async function getPolicyTemplates(
  options?: UsePolicyTemplatesOptions
): Promise<Array<PolicyTemplate>> {
  try {
    const params = new URLSearchParams();
    if (options?.category) {
      params.append('category', options.category);
    }
    if (options?.type) {
      params.append('type', options.type);
    }

    const queryString = params.toString();
    const url = queryString
      ? `/policies/templates?${queryString}`
      : '/policies/templates';

    const { data } = await axios.get<PolicyTemplatesResponse>(url);
    return data.templates;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to retrieve policy templates');
  }
}
